import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { DeliveryMethod } from '../../../contexts/contextTypes';

interface UpdateDeliveryTypePayload {
  taskId: string;
  deliveryType: DeliveryMethod;
  pickupPointId?: string;
}

interface UpdateDeliveryTypeParams {
  packageId: string;
  payload: UpdateDeliveryTypePayload;
}

export const useUpdateDeliveryType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ packageId, payload }: UpdateDeliveryTypeParams) => {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/v1/package/${packageId}/updateDeliveryType`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(['trackingDetails', variables.packageId]);
    }
  });
};
